export default () => ({
  table: {

    '& td, th': {
      border: '1px solid #DFE3E8',
    }
  },
});
